module.exports = __webpack_public_path__ + "static/media/a-3-a.6c3d2b28.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/accessroies/a-3-a.jpg
// module id = 1096
// module chunks = 33